{
  "name": "Magma Run",
  "subtitle": "Pillars, spikes and one very hot shortcut. Don't look down.",
  "spawn": [0, 2, 3],
  "killY": -10,
  "cameraYaw": -1.5708,
  "timeLimit": 95,
  "theme": { "sky": "#2b1220", "fog": "#6e2418", "fogDistance": 45, "light": "#ffb47a" },
  "platforms": [
    { "position": [0, 0, 0], "size": [10, 1, 10], "color": "#4a3a42" },
    { "position": [8, 1, 0], "size": [3, 1, 3], "color": "#5c4148" },
    { "position": [13, 2, 3], "size": [3, 1, 3], "color": "#5c4148" },
    { "position": [18, 3, 0], "size": [3, 1, 3], "color": "#5c4148" },
    { "position": [23, 2, -3], "size": [3, 1, 3], "color": "#5c4148" },
    { "position": [29, 2, -3], "size": [7, 1, 7], "color": "#4a3a42" },
    { "position": [34, 1, -3], "size": [3, 0.8, 3], "surface": "bounce" },
    { "position": [40, 6, -3], "size": [6, 1, 6], "color": "#4a3a42" },
    { "position": [40, 9.5, 3], "size": [3, 0.8, 3], "color": "#5c4148" },
    {
      "position": [47, 6, -3],
      "size": [4, 0.8, 4],
      "color": "#8a5a3a",
      "move": { "offset": [0, 0, 7], "duration": 5 }
    },
    { "position": [52, 6, -3], "size": [4, 1, 4], "surface": "hurt" },
    { "position": [58, 6.5, -3], "size": [8, 1, 8], "color": "#4a3a42" }
  ],
  "pickups": [
    {
      "item": "coin",
      "position": [-3, 2, 0],
      "repeat": { "count": 4, "to": [3, 2, 0] }
    },
    { "item": "coin", "position": [8, 3, 0] },
    { "item": "coin", "position": [13, 4, 3] },
    { "item": "coin", "position": [18, 5, 0] },
    { "item": "coin", "position": [23, 4, -3] },
    { "item": "boots", "position": [29, 4, -3] },
    { "item": "gem", "position": [40, 11, 3] },
    { "item": "feather", "position": [40, 8, -3] },
    {
      "item": "coin",
      "position": [47, 8, -3],
      "repeat": { "count": 3, "to": [47, 8, 3] }
    },
    { "item": "clock", "position": [58, 8.5, -3] },
    { "item": "heart", "position": [58, 8.5, 0] }
  ],
  "enemies": [
    { "enemy": "walker", "position": [3, 0, -3], "patrolTo": [-3, 0, -3] },
    { "enemy": "spike", "position": [27, 2, -1] },
    { "enemy": "spike", "position": [31, 2, -5] },
    {
      "enemy": "stalker",
      "position": [29, 2, -3],
      "overrides": { "speed": 4.8 }
    },
    { "enemy": "hopper", "position": [37, 7, -3] },
    { "enemy": "stalker", "position": [58, 6.5, -1] },
    {
      "enemy": "spinner",
      "position": [58, 6.5, -3],
      "overrides": { "speed": 3.6 }
    }
  ],
  "goal": { "position": [61, 6.5, 0], "requires": 10 }
}
